"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionTypeEnum = void 0;
var DistributionTypeEnum;
(function (DistributionTypeEnum) {
    DistributionTypeEnum["Accumulation"] = "Acc";
    DistributionTypeEnum["Distribution"] = "Dist";
})(DistributionTypeEnum = exports.DistributionTypeEnum || (exports.DistributionTypeEnum = {}));
//# sourceMappingURL=distribution-type-enum.js.map